import { useState, useEffect } from "react"

const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState<number>(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }

    window.addEventListener("scroll", handleScroll)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, []) // Empty dependency array ensures this effect runs only once on mount

  return scrollPosition
}

export default useScrollPosition
